"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var SvgImageFilled = function (props) { return (react_1.default.createElement("svg", __assign({ width: '1em', height: '1em', viewBox: '0 0 24 24' }, props),
    react_1.default.createElement("path", { fillRule: 'evenodd', clipRule: 'evenodd', d: 'M2.193 20.917l-.013.001L4 19.326l3.143-3.035 2.642 1.962c.495.336 1.016.457 1.564.363a1.84 1.84 0 001.28-.841l2.82-4.135L20 17.274l1.986 1.594.014-.001v1.13C22 21.332 21.333 22 20 22H4c-.979 0-1.598-.36-1.859-1.078l.052-.005zM22 16.544L20 15l-3.297-2.637c-.549-.36-1.087-.501-1.613-.424-.527.077-.96.369-1.3.876L11 17l-2.612-1.96c-.508-.298-.975-.43-1.4-.395-.425.035-.83.228-1.215.582L4 17l-2 1.77v.615V4c0-1.333.667-2 2-2h16c1.333 0 2 .667 2 2v12.544zM9 10.919a2 2 0 100-4 2 2 0 000 4z' }))); };
exports.default = SvgImageFilled;
//# sourceMappingURL=ImageFilled.js.map